import React, { useState } from "react";
import { Smartphone } from "lucide-react";
import AppDownloadLink from "./AppDownloadLink";
import { detectDevice, isPhone, isStandalone } from "../../hooks/useInstallPrompt";

// Phones only: compact "Get app" button beside the hero "AI app builder" badge.
export const HeroGetAppChip = () => {
  const [device] = useState(detectDevice);
  if (!isPhone() || isStandalone()) return null;
  return (
    <AppDownloadLink source="hero_badge" device={device} testid="hero-get-app-chip"
      className="group inline-flex items-center gap-1.5 h-8 pl-1 pr-3 rounded-full bg-slate-900 text-white text-xs font-semibold shadow-sm hover:bg-slate-700 transition-colors">
      <span className="w-6 h-6 rounded-[8px] bg-sky-500 flex items-center justify-center transition-transform duration-200 group-hover:-rotate-12">
        <Smartphone size={13} />
      </span>
      Get app
    </AppDownloadLink>
  );
};

export default HeroGetAppChip;
